export const languageSelectorCommon = {
  key: 'languageSelectorCommon',
  name: 'Language Selector Common',
  siteIdentifier: 'global',

  languageSelectorTitle: 'Choose your language',
  languageSelectorFrenchLocale: 'Français (CAD)',
  languageSelectorEnglishLocale: 'English (CAD)',
  languageSelectorButton: 'Set Language',
};
